import { Component, NgZone, OnInit, Input , ElementRef  } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormControl, Validators } from '@angular/forms';
import { ListCompanies } from '../models/company.model';
import { CompanyService } from './../services/company.service';
import { ListCountries, ZoneElement } from './../models/zone.model';
import { ZoneService } from '../services/zone.service';
import { MenusComponent } from './../menus/menus.component';
import { DialogService } from '../services/dialog.service';
import { LanguageService } from '../services/language.service';
import { TranslocoService } from '@jsverse/transloco';
import { StorageService } from '../services/storage.service';

@Component({
  selector: 'app-zone',
  templateUrl: './zone.component.html',
  styleUrl: './zone.component.css'
})

export class ZoneComponent implements OnInit {

  constructor(public ngZone: NgZone, private router: Router, private route: ActivatedRoute,
              private companyService: CompanyService, private zoneService: ZoneService,
              private menusComponent: MenusComponent, private dialogService: DialogService,
              private langService: LanguageService, private translocoService: TranslocoService,
              public storageService: StorageService) { }

  public titleZone = "Zona";
  public new = false;
  @Input() id: number=0;
  companyControl = new FormControl('', [Validators.required]);
  role:number = 10;
  lstCountries:ListCountries[] = []
  lstCompanies: ListCompanies[] = [];
  item: any = [];

  name_Input:string="";
  company_Selected:number=0;
  country_Selected:string="";
  description:string="";

  zone: ZoneElement = {
    id: 0,
    name: '',
    company_id: 0,
    country_id: '',
    description: ''
  }

  ngOnInit(): void {
    this.route.queryParams.
      subscribe(params => {
        this.id = (params['id']);
      });

      const currentLang = this.langService.getLang();
    if(this.id > 0){
      this.new = false
      this.translocoService.selectTranslate('zone.titleEdit')
      .subscribe((translatedTitle: string) => {
        this.titleZone = translatedTitle;
      });

      //GET
      const req=this.zoneService.getZoneById(this.id, this.storageService.companyId);
      req.subscribe({
        next: (res) => {
          this.item = res;
          if(this.item.data != null){
            this.name_Input = this.item.data.name;
            this.company_Selected = this.item.data.company_id;
            this.description = this.item.data.description;
            this.country_Selected = this.item.data.country_code;
          }
        },
        error: (e) => {
          console.error(e);
          let msg = e.error.message;
        },
      });

    }else{
      this.new = true
      this.company_Selected = this.storageService.companyId
      this.translocoService.selectTranslate('zone.titleNew')
      .subscribe((translatedTitle: string) => {
        this.titleZone = translatedTitle;
      });
    }

    this.role=this.storageService.roleId;
    this.lstCompanies=this.companyService.getCompaniesListByRol(this.storageService.roleId,
                                                                this.storageService.companyId);
    this.lstCountries=this.zoneService.getCountries();
  }

  onGuardarItm(){
    console.log(this.company_Selected)
    if (!(this.company_Selected > 0) ){
      return;
    }
    let msg:string="";
    if (this.new ){
      //ADD
      this.zone = {
        id: 0,
        name: this.name_Input,
        company_id: this.company_Selected,
        country_id: this.country_Selected,
        description: this.description
      }
      this.zoneService.addZone(this.zone, this.storageService.companyId)
      .subscribe({
        next: (res) => {
          msg = res.message;
          console.log(msg);
          this.msgDialog(msg, '', true, 'O');
        },
        error: (e) => {
          msg = e.error.message;
          console.error(e);
          this.msgDialog('ERROR', msg, false, 'E');
        },
      });
    }else{
      //UPDATE
      this.zone = {
        id: this.id,
        name: this.name_Input,
        company_id: this.company_Selected,
        country_id: this.country_Selected,
        description: this.description
      }
      this.zoneService.updateZone(this.id, this.zone, this.storageService.companyId)
      .subscribe({
        next: (res) => {
          msg = res.message;
          console.log(msg);
          this.msgDialog(msg, '', true, 'O');
        },
        error: (e) => {
          msg = e.error.message;
          console.error(e);
          this.msgDialog('ERROR', msg, false, 'E');
        },
      });
    }
  }

  msgDialog(msgShow:string, msg2Show:string, isOK:boolean, type:string){
    this.dialogService.confirmDialog({
      title: 'Zona',
      message: msgShow,
      message2: msg2Show,
      confirmText: 'OK',
      cancelText: '',
      showConfirmBox: false,
      dialogType: type,
    })
    .subscribe((yes) => {
      if (isOK) {
        setTimeout(() => {
          this.router.navigate(['zones']);
        }, 1000);
      }
    });
  }

  EliminarItm(){
    //DELETE
    let msg:string="";
    this.zoneService.deleteZone(this.id, this.storageService.companyId)
    .subscribe({
      next: (res) => {
        msg = res.message;
        console.log(msg);
        this.msgDialog(msg, '', true, 'O');
      },
      error: (e) => {
        msg = e.error.message;
        console.error(e);
        this.msgDialog('ERROR', msg, false, 'E');
      },
    });
  }

  onEliminarItm() {
    this.dialogService.confirmDialog({
      title: this.translocoService.translate('zone.msgTitle'),
      message: this.translocoService.translate('zone.msgMessage'),
      message2: this.translocoService.translate('zone.msgMessage2'),
      confirmText: this.translocoService.translate('zone.confirmText'),
      cancelText: this.translocoService.translate('zone.cancelText'),
        showConfirmBox: true,
        dialogType: 'A',
    })
    .subscribe((yes) => {
      if (yes) {
        this.EliminarItm();
        console.log('Si Eliminar.');
      }
    });
  }

}
